import { ChangeEvent, useEffect, useState } from 'react'
import styles from './index.module.css'
import spy from '../../assets/spy-svgrepo-com.svg'
import cancel from '../../assets/cancel-svgrepo-com.svg'

import { Button } from 'antd'

export default function Impersonation({
  updateImpersonation = (_email: string) => {
    console.error('empty parent function')
  },
  impersonatedUser = null,
}: {
  updateImpersonation: (_email: string) => void
  impersonatedUser: string | null
}) {
  const [impersonationEmail, setImpersonationEmail] = useState<string | null>(
    impersonatedUser,
  )
  const [validEmail, setIsValidEmail] = useState<boolean>(false)

  const setGlobalImpersonation = function () {
    if (isValidImpersonation(impersonationEmail as string)) {
      updateImpersonation(impersonationEmail as string)
    }
  }

  const clearGlobalImpersonation = function () {
    updateImpersonation('')
  }

  const updateImpersonationEmail = function (
    event: ChangeEvent<HTMLInputElement>,
  ) {
    if (!event.target) return
    const value = (event.target as HTMLInputElement).value
    setImpersonationEmail(value)
    setIsValidEmail(isValidImpersonation(value))
  }

  const isValidImpersonation = function (testString: null | string) {
    return /[A-z]{1,}@turbodebt.com$/.test(testString as string)
  }

  useEffect(() => {
    setIsValidEmail(isValidImpersonation(impersonationEmail))
  }, [impersonatedUser])

  return (
    <div>
      {impersonatedUser === '' && (
        <div className={styles.impersonateContainer}>
          <img className={styles.impersonateIcon} src={spy}></img>
          <span>Impersonate User:</span>
          <input
            value={impersonationEmail as string}
            name="impersonation"
            type="text"
            style={{ height: '18px' }}
            onChange={updateImpersonationEmail}
          />
          <Button
            color={'cyan'}
            icon={<img height={18} src={spy} />}
            variant={'solid'}
            disabled={!validEmail}
            onClick={setGlobalImpersonation}
          >
            Impersonate
          </Button>
        </div>
      )}

      {impersonatedUser !== '' && (
        <div className={styles.impersonateContainer}>
          <span>Impersonating user {impersonatedUser}</span>
          <Button
            color={'danger'}
            icon={<img height={18} src={cancel} />}
            variant={'solid'}
            onClick={clearGlobalImpersonation}
          >
            Stop Impersonation
          </Button>
        </div>
      )}
    </div>
  )
}
